import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";

import permits from "@/ts/modules/permits";
import reporting from "@/ts/modules/reporting";
import components from "@/ts/modules/components";

Vue.use(VueRouter);

const routes: RouteConfig[] = [
	{
		path: "/",
		redirect: "/Home",
		name: "App",
		component: { template: "<router-view/>" }
	},
	{
		path: "/Home",
        name: "Home",
        component: components.Home
    },

    // Permits
    {
        path: "/Permits",
        name: "Permits",
        component: components.Permits
    },

    // CCDD
    {
        path: "/Permits/CCDDApplication/:applicationNumber?",
        name: "CCDDApplication",
        props: { formType: "Permits", formName: "CCDDApplication" },
        component: components.FormWrapper,
        children: [
            {
                path: "ContactEmail",
                name: "CCDDApplicationContactEmail",
                component: permits.ContactEmail
            },
            {
                path: "SiteInfo",
                name: "CCDDApplicationSiteInfo",
                component: permits.SiteInfo
            },
            {
                path: "AcceptedMaterials",
                name: "CCDDApplicationAcceptedMaterials",
                props: { formName: "" },
                component: permits.CCDD.AcceptedMaterials
            },
            {
                path: "OperatingHours",
                name: "CCDDApplicationOperatingHours",
                component: permits.OperatingHours
            },
            {
                path: "DailyOperations",
                name: "CCDDApplicationDailyOperations",
                component: permits.CCDD.DailyOperations
            },
            {
                path: "Violations",
                name: "CCDDApplicationViolations",
                component: permits.CCDD.CCDDViolations
            },
            {
                path: "Signature",
                name: "CCDDApplicationSignature",
                component: permits.Signature
            },
        ],
        redirect: "/Permits/CCDDApplication/:applicationNumber?/ContactEmail"
    },

    // CCDD Renewal
    {
        path: "/Permits/Renewal/CCDDApplication/:applicationNumber?",
        name: "CCDDApplication",
        props: { formType: "Permits", formName: "CCDDApplication", isRenewal: true },
        component: components.FormWrapper,
        children: [
            {
                path: "ContactEmail",
                name: "CCDDApplicationContactEmail",
                props: { isRenewal: true },
                component: permits.ContactEmail
            },
            {
                path: "SiteInfo",
                name: "CCDDApplicationSiteInfo",
                props: { isRenewal: true },
                component: permits.SiteInfo
            },
            {
                path: "SiteInfoRenewal",
                name: "CCDDApplicationSiteInfoRenewal",
                props: { isRenewal: true },
                component: permits.SiteInfoRenewal
            },
            {
                path: "AcceptedMaterials",
                name: "CCDDApplicationAcceptedMaterials",
                props: { formName: "" },
                component: permits.CCDD.AcceptedMaterials
            },
            {
                path: "OperatingHours",
                name: "CCDDApplicationOperatingHours",
                component: permits.OperatingHours
            },
            {
                path: "DailyOperations",
                name: "CCDDApplicationDailyOperations",
                component: permits.CCDD.DailyOperations
            },
            {
                path: "Violations",
                name: "CCDDApplicationViolations",
                component: permits.CCDD.CCDDViolations
            },
            {
                path: "Signature",
                name: "CCDDApplicationSignature",
                component: permits.Signature
            },
        ],
        redirect: "/Permits/Renewal/CCDDApplication/:applicationNumber?/ContactEmail"
    },

    // Recycling Facility
    {
        path: "/Permits/RecyclingFacilityApplication/:applicationNumber?",
        name: "RecyclingFacilityApplication",
        props: { formType: "Permits", formName: "RecyclingFacilityApplication" },
        component: components.FormWrapper,
        children: [
            {
                path: "ContactEmail",
                name: "RecyclingFacilityContactEmail",
                component: permits.ContactEmail
            },
            {
                path: "SiteInfo",
                name: "RecyclingFacilitySiteInfo",
                component: permits.SiteInfo
            },
            {
                path: "AcceptedMaterials",
                name: "RecyclingFacilityAcceptedMaterials",
                component: permits.RecyclingFacility.AcceptedMaterials
            },
            {
                path: "OperatingHours",
                name: "RecyclingFacilityOperatingHours",
                component: permits.OperatingHours
            },
            {
                path: "DailyOperations",
                name: "RecyclingFacilityDailyOperations",
                component: permits.RecyclingFacility.DailyOperations
            },
            {
                path: "LiquidHazardousWaste",
                name: "RecyclingFacilityLiquidHazardousWaste",
                component: permits.RecyclingFacility.OpsLhw
            },
            {
                path: "Violations",
                name: "RecyclingFacilityViolations",
                component: permits.RecyclingFacility.OpsViolations
            },
            {
                path: "Signature",
                name: "RecyclingFacilitySignature",
                component: permits.Signature
            },
        ],
        redirect: "/Permits/RecyclingFacilityApplication/:applicationNumber?/ContactEmail"
    },

    //Recycling Facility Renewal
    {
        path: "/Permits/Renewal/RecyclingFacilityApplication/:applicationNumber?",
        name: "RenewalRecyclingFacilityApplication",
        props: { formType: "Permits", formName: "RecyclingFacilityApplication", isRenewal: true },
        component: components.FormWrapper,
        children: [
            {
                path: "ContactEmail",
                props: { isRenewal: true },
                name: "RecyclingFacilityContactEmail",
                component: permits.ContactEmail
            },
            {
                path: "SiteInfo",
                name: "RecyclingFacilitySiteInfo",
                props: { isRenewal: true },
                component: permits.SiteInfo
            },
            {
                path: "SiteInfoRenewal",
                name: "RecyclingFacilityRenewalSiteInfo",
                props: { isRenewal: true },
                component: permits.SiteInfoRenewal
            },
            {
                path: "AcceptedMaterials",
                name: "RecyclingFacilityAcceptedMaterials",
                component: permits.RecyclingFacility.AcceptedMaterials
            },
            {
                path: "OperatingHours",
                name: "RecyclingFacilityOperatingHours",
                component: permits.OperatingHours
            },
            {
                path: "DailyOperations",
                name: "RecyclingFacilityDailyOperations",
                component: permits.RecyclingFacility.DailyOperations
            },
            {
                path: "LiquidHazardousWaste",
                name: "RecyclingFacilityLiquidHazardousWaste",
                component: permits.RecyclingFacility.OpsLhw
            },
            {
                path: "Violations",
                name: "RecyclingFacilityViolations",
                component: permits.RecyclingFacility.OpsViolations
            },
            {
                path: "Signature",
                name: "RecyclingFacilitySignature",
                component: permits.Signature
            },
        ],
        redirect: "/Permits/Renewal/RecyclingFacilityApplication/:applicationNumber?/ContactEmail"
    },

    // Rock Crushing
    {
        path: "/Permits/RockCrushingApplication/:applicationNumber?",
        name: "RockCrushingApplication",
        props: { formType: "Permits", formName: "RockCrushingApplication", ignoreFileLimit: true },
        component: components.FormWrapper,
        children: [
            {
                path: "ContactEmail",
                name: "RockCrushingContactEmail",
                component: permits.RockCrushing.ContactEmail
            },
            {
                path: "SiteInfo",
                name: "RockCrushingSiteInfo",
                component: permits.RockCrushing.SiteInfo
            },
            {
                path: "AcceptedMaterials",
                name: "RockCrushingAcceptedMaterials",
                component: permits.RockCrushing.AcceptedMaterials
            },
            {
                path: "Signature",
                name: "RockCrushingSignature",
                component: permits.RockCrushing.Signature
            }
        ],
        redirect: "/Permits/RockCrushingApplication/:applicationNumber?/ContactEmail"
    },

    // Rock Crushing Renewal
    {
        path: "/Permits/RockCrushingRenewal/:applicationNumber",
        name: "RockCrushingRenewal",
        props: { formType: "Permits", formName: "RockCrushingRenewal", ignoreFileLimit: false },
        component: components.TRCRenewal
    },

    // Permits/Review
    {
        path: "/Permits/Review/RockCrushingApplication/:applicationNumber",
        name: "PermitsReviewTRC",
        component: permits.RockCrushing.Review
    },
    
    // Permits/Review/RockCrushingRenewal
    {
      path: "/Permits/Review/RockCrushingRenewal/:applicationNumber",
      name: "RockCrushingRenewalReview",
      component: permits.RockCrushing.RenewalReview  
    },

    // Permits/Review
    {
        path: "/Permits/Review/:formName/:applicationNumber",
        name: "PermitsReview",
        component: permits.Review,
    },
    
    

    // Reporting
    {
        path: "/Reporting",
        name: "Reporting",
        component: components.Reporting
    },
    // CCDD Activities
    {
        path: "/Reporting/CCDDActivities/:applicationNumber?",
        name: "CCDDActivities",
        props: { formType: "Reporting", formName: "CCDDActivities" },
        component: components.FormWrapper,
        children: [
            {
                path: "FacilityInfo",
                name: "CCDDActivitiesFacilityInfo",
                component: reporting.CCDD.FacilityInfo
            },
            {
                path: "Materials",
                name: "CCDDActivitiesMaterials",
                component: reporting.CCDD.Materials
            },
            {
                path: "Certification",
                name: "CCDDActivitiesCertification",
                component: reporting.Certification
            }
        ],
        redirect: "/Reporting/CCDDActivities/:applicationNumber?/FacilityInfo"
    },

    // Liquid Hazardous Waste
    {
        path: "/Reporting/LiquidHazardousWaste/:applicationNumber?",
        name: "LiquidHazardousWaste",
        props: { formType: "Reporting", formName: "LiquidHazardousWaste" },
        component: components.FormWrapper,
        children: [
            {
                path: "FacilityInfo",
                name: "LiquidHazardousWasteFacilityInfo",
                component: reporting.LHW.FacilityInfo
            },
            {
                path: "Materials",
                name: "LiquidHazardousWasteMaterials",
                component: reporting.LHW.Materials
            },
            {
                path: "Certification",
                name: "LiquidHazardousWasteCertification",
                component: reporting.Certification
            }
        ],
        redirect: "/Reporting/LiquidHazardousWaste/:applicationNumber?/FacilityInfo"
    },

    // Non-Residential Hauler
    {
        path: "/Reporting/NonResidentialHauler/:applicationNumber?",
        name: "NonResidentialHauler",
        props: { formType: "Reporting", formName: "NonResidentialHauler" },
        component: components.FormWrapper,
        children: [
            {
                path: "FacilityInfo",
                name: "NonResidentialHaulerFacilityInfo",
                component: reporting.NRH.FacilityInfo
            },
            {
                path: "Materials",
                name: "NonResidentialHaulerMaterials",
                component: reporting.NRH.Materials
            },
            {
                path: "Certification",
                name: "NonResidentialHaulerCertification",
                component: reporting.Certification
            }
        ],
        redirect: "/Reporting/NonResidentialHauler/:applicationNumber?/FacilityInfo"
    },

    // Recycling Activities
    {
        path: "/Reporting/RecyclingActivities/:applicationNumber?",
        name: "RecyclingActivities",
        props: { formType: "Reporting", formName: "RecyclingActivities" },
        component: components.FormWrapper,
        children: [
            {
                path: "FacilityInfo",
                name: "RecyclingActivitiesFacilityInfo",
                component: reporting.RA.FacilityInfo
            },
            {
                path: "Materials",
                name: "RecyclingActivitiesMaterials",
                component: reporting.RA.Materials
            },
            {
                path: "Certification",
                name: "RecyclingActivitiesCertification",
                component: reporting.Certification
            }
        ],
        redirect: "/Reporting/RecyclingActivities/:applicationNumber?/FacilityInfo"
    },

    // Residential Hauler
    {
        path: "/Reporting/ResidentialHauler/:applicationNumber?",
        name: "ResidentialHauler",
        props: { formType: "Reporting", formName: "ResidentialHauler" },
        component: components.FormWrapper,
        children: [
            {
                path: "FacilityInfo",
                name: "ResidentialHaulerFacilityInfo",
                component: reporting.RH.FacilityInfo
            },
            {
                path: "Materials",
                name: "ResidentialHaulerMaterials",
                component: reporting.RH.Materials
            },
            {
                path: "Certification",
                name: "ResidentialHaulerCertification",
                component: reporting.Certification
            }
        ],
        redirect: "/Reporting/ResidentialHauler/:applicationNumber?/FacilityInfo"
    },

    // Transfer Station
    {
        path: "/Reporting/TransferStation/:applicationNumber?",
        name: "TransferStation",
        props: { formType: "Reporting", formName: "TransferStation" },
        component: components.FormWrapper,
        children: [
            {
                path: "FacilityInfo",
                name: "TransferStationFacilityInfo",
                component: reporting.XFR.FacilityInfo
            },
            {
                path: "Materials",
                name: "TransferStationMaterials",
                component: reporting.XFR.Materials
            },
            {
                path: "Certification",
                name: "TransferStationCertification",
                component: reporting.Certification
            }
        ],
        redirect: "/Reporting/TransferStation/:applicationNumber?/FacilityInfo"
    },

    // Reporting Review
    {
        path: "/Reporting/Review/:formName/:applicationNumber",
        name: "ReportingReview",
        component: reporting.Review
    },

    // Application Saved
    {
        path: "/Saved/:applicationNumber",
        name: "FormSaved",
        component: components.FormSaved
    },
    // Application Search
    {
        path: "/Search/:searchType",
        name: "FormSearch",
        component: components.FormSearch
    },
    // Checkout
    {
        path: "/Checkout/:applicationNumber",
        name: "Checkout",
        component: components.Checkout
    },
    // Thank You
    {
        path: "/ThankYou/:payType/:applicationNumber/:returnSessionId?/:confirmationNumber?/:transactionMode?/:amount?",
        name: "ThankYou",
        component: components.ThankYou
    },
    {
        path: "/ThankYouNoFee/:formType/:applicationNumber",
        name: "ThankYouNoFee",
        component: components.ThankYouNoFee
    },
	//404
    { path: "/404", component: components.NotFound },
	{ path: "*", redirect: "/404" }
];

export default new VueRouter({
    //mode: "history",
    routes: routes
});
